import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import * as _ from "lodash";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const ModelCoefficientSetSearch: ISearch = {
    searchName: "Find Model Coefficient",
    renderOptions: {ui5ResourceId: "ModelCoefficientSetSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
};

const vUI_Model_Coefficient_Set_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_MODEL_COEFF_SET_ID:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Model Coefficient Id',     columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    MODEL_COEFF_SET_ID:              {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Coefficient Set Id',            columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MODEL_COEFF_SET_NAME:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Coefficient Set Name',          columnResourceName: 'colModelName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MODEL_NAME:                 {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Name',          columnResourceName: 'colModelName',      alignment: HorizAlignment.Left}, domainOptions: { search: ModelCoefficientSetSearch, profileId: "ModelCoefficientSetSearchProfileByName", bUseSearchProvidersDistinctValues: true, maxLength: 50}},CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ModelCoefficientSetSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_MODEL_COEFF_SET_ID',
        id_ui: 'MODEL_COEFF_SET_ID',
        name:  'MODEL_COEFF_SET_NAME'

    },

    searchProviderFields: vUI_Model_Coefficient_Set_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Coefficient_Set_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Model_Coefficient_Set_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {

                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
};

const ModelCoefficientSetSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ModelCoefficientSetSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'MODEL_COEFF_SET_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MODEL_COEFF_SET_NAME', renderOptions: {}},
        {profileFilterName: 'Model', searchProviderFieldId: 'MODEL_NAME', bMultiSelect: true, renderOptions: { }}
    ], //ISearchFields
    profileDisplayFields: [
        'MODEL_COEFF_SET_ID', 'MODEL_COEFF_SET_NAME', 'MODEL_NAME',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelCoefficientSetSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

ModelCoefficientSetSearch.searchProfiles = [ModelCoefficientSetSearchProfileByName]
PAEnvironment.registerBusinessObjectSearch("ModelCoefficientSetBO", "ModelCoefficientSet", ModelCoefficientSetSearch, "Model Coefficient Set Search")

export {ModelCoefficientSetSearch}